// gtm-events.js
window.dataLayer = window.dataLayer || [];

 function getParamFromURL(param, _url){
      if(!_url) _url = window.location.href;
  
      var url = new URL(_url);
      var search_params = url.searchParams;
      var paramVal = search_params.get(param);
  
      return paramVal;
}

function deleteParamFromURL(param, _url){
      if(!param) return null;
      if(!_url) _url = window.location.href;
      var url = new URL(_url);
      var search_params = url.searchParams;
      search_params.delete(param);
      var new_url = url.toString();
      return new_url;
}

function _debounce(func, wait) {
  let timeout;

  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class AlteregoAnalytics {
    constructor() {
      this.isMobile = window.innerWidth < 768;
  
      this.lastDesktopMenuInteractionTime = 0;
      this.trackPredictiveSearchSuccess();
      this.trackPlpSelectItem();
      this.trackPlpFilterApply();
      this.trackLeadForms();
      this.trackGridBannerPromotions();
      this.trackAgeVerification();
      this.trackLoginInitiation();
      this.trackPostLogin();
      this.trackCartQuantityChange();
    }

    /* ----------------------- Search Tracking -------------------------*/
    trackSearchSuccess(inputElement) {
        const searchTerm = inputElement?.value || "";
        if (!searchTerm.trim()) return;
    
        Shopify.analytics.publish('on_search_success', {
          event: "search_success",
          searchTerm: searchTerm,
        });
    }
  
    trackPredictiveSearchSuccess() {
        // Predictive search
        const predictiveForm = document.querySelector("form.search");
        const predictiveResults = document.querySelector(".predictive-search");
      
        if (predictiveForm && predictiveResults) {
          predictiveForm.addEventListener("submit", () => {
            this.trackSearchSuccess(predictiveForm.querySelector("input[type='search']"));
          });
      
          let predictiveSearchTracked = false;
          const observerPredictive = new MutationObserver(() => {
            if (!predictiveSearchTracked) {
                this.trackSearchSuccess(predictiveForm.querySelector("input[type='search']"));
              predictiveSearchTracked = true;
              
              // Reset tracking flag after 2 seconds to allow new searches
              setTimeout(() => {
                predictiveSearchTracked = false;
              }, 2000);
            }
          });
      
          observerPredictive.observe(predictiveResults, {
            childList: true,
            subtree: true
          });
        }
    }

    trackReorderClick(order) {
      if (!order) return;
      Shopify.analytics.publish('on_reorder_click', {
        event: 'reorder_click',
        order_id: order.order_id,
        item_count: order.item_count,
        order_date: order.order_date,
      });
    }

    trackPreviousOrderReorder(payload) {
      if (!payload || payload.order_id == null || payload.order_id === '') return;
      Shopify.analytics.publish('on_previous_order_reorder', {
        event: 'previous_order_reorder',
        order_id: payload.order_id,
        items: Array.isArray(payload.items) ? payload.items : [],
        total_value: payload.total_value,
      });
    }

    trackSelectItem(data) {
      if (!data || data.item_id == null || data.item_id === '') return;
      Shopify.analytics.publish('on_select_item', {
        event: 'select_item',
        item_id: data.item_id,
        item_name: data.item_name || '',
        item_list_name: data.item_list_name || '',
        item_list_id: data.item_list_id || '',
        index: data.index,
      });
    }

    trackFilterApply(data) {
      if (!data || data.filter_type == null || data.filter_type === '') return;

      Shopify.analytics.publish('on_filter_apply', {
        event: 'filter_apply',
        filter_type: data.filter_type,
        filter_value: data.filter_value || '',
        results_count: data.results_count,
      });
    }

    getPlpResultsCount() {
      const countEl =
        document.getElementById('ProductCount') || document.getElementById('ProductCountDesktop');
      const count = parseInt(countEl?.dataset?.resultsCount, 10);
      return Number.isFinite(count) ? count : undefined;
    }

    getFacetFilterLabel(target, filterLabel) {
      if (filterLabel) return filterLabel;

      const filterGroup = target?.closest?.('.js-filter');
      if (filterGroup?.dataset?.filterLabel) return filterGroup.dataset.filterLabel;

      const summaryLabel = filterGroup?.querySelector('.facets__summary-label');
      if (summaryLabel) {
        return summaryLabel.textContent.trim().replace(/\s*\(\d+\)\s*$/, '');
      }

      const mobileSummaryLabel = filterGroup?.querySelector(
        '.mobile-facets__summary > div > span:first-child'
      );
      if (mobileSummaryLabel) return mobileSummaryLabel.textContent.trim();

      return '';
    }

    getFacetValueLabel(target) {
      const item = target?.closest?.('.facets__item, .mobile-facets__item');
      const valueLabel = item?.querySelector('.facet-checkbox__text-label')?.textContent?.trim();
      if (valueLabel) return valueLabel;
      return target?.value || '';
    }

    getFilterDetailsFromEvent(detail) {
      const event = detail?.event ?? detail;
      if (!event) return null;

      const target = event.target;
      const currentTarget = event.currentTarget;
      const filterLabel = detail?.filterLabel || '';

      if (target?.name === 'sort_by') {
        const select = target.closest('select') || target;
        const option = select.options?.[select.selectedIndex];
        return {
          filter_type: 'Sort',
          filter_value: option?.textContent?.trim() || option?.value || target.value || '',
        };
      }

      if (target?.type === 'checkbox') {
        const filterType = this.getFacetFilterLabel(target, filterLabel);
        return {
          filter_type: filterType || 'filter',
          filter_value: this.getFacetValueLabel(target),
        };
      }

      if (target?.type === 'text' && target.name?.includes('filter')) {
        const filterType = this.getFacetFilterLabel(target, filterLabel) || 'Price';
        const priceRange = target.closest('price-range');
        const minInput = priceRange?.querySelector('input[name*="filter"]');
        const maxInput = priceRange?.querySelectorAll('input[name*="filter"]')?.[1];
        return {
          filter_type: filterType,
          filter_value: `${minInput?.value || ''}-${maxInput?.value || ''}`,
        };
      }

      const removeLink = currentTarget?.closest?.('a') || target?.closest?.('.active-facets__button');
      if (removeLink?.classList?.contains('active-facets__button-remove')) {
        return { filter_type: 'clear_all', filter_value: 'all' };
      }
      if (removeLink) {
        const pillText = removeLink
          .querySelector('.active-facets__button-inner')
          ?.textContent?.replace(/\s+/g, ' ')
          .trim();
        if (pillText) {
          const [filterType, ...rest] = pillText.split(':');
          return {
            filter_type: filterType?.trim() || 'filter',
            filter_value: rest.join(':').trim() || 'removed',
          };
        }
      }

      return null;
    }

    trackPlpFilterApply() {
      if (!document.getElementById('product-grid')) return;

      document.addEventListener('pk:plp-filter-applied', (e) => {
        const details = this.getFilterDetailsFromEvent(e.detail);
        if (!details) return;

        this.trackFilterApply({
          ...details,
          results_count: this.getPlpResultsCount(),
        });
      });
    }

    trackGenerateLead(data) {
      if (!data || !data.form_name) return;

      Shopify.analytics.publish('on_generate_lead', {
        event: 'generate_lead',
        form_name: data.form_name,
        form_location: data.form_location || window.location.pathname,
      });
    }

    trackLeadFormSubmit(form) {
      if (!form?.dataset?.analyticsLead) return;

      this.trackGenerateLead({
        form_name: form.dataset.analyticsFormName || 'Contact',
        form_location: form.dataset.analyticsFormLocation || window.location.pathname,
      });
    }

    trackLeadForms() {
      document.addEventListener('submit', (e) => {
        const form = e.target?.closest?.('form[data-analytics-lead]');
        if (!form || form.id === 'ContactForm') return;

        this.trackLeadFormSubmit(form);
      });
    }

    trackViewPromotion(data) {
      if (!data || data.promotion_id == null || data.promotion_id === '') return;

      Shopify.analytics.publish('on_view_promotion', {
        event: 'view_promotion',
        promotion_id: data.promotion_id || '',
        promotion_name: data.promotion_name || '',
        creative_name: data.creative_name || '',
        creative_slot: data.creative_slot || '',
      });
    }

    trackGridBannerPromotions() {
      document.addEventListener('click', (e) => {
        const tile = e.target.closest('[data-analytics-promotion]');
        if (!tile) return;

        this.trackViewPromotion({
          promotion_id: tile.dataset.promotionId,
          promotion_name: tile.dataset.promotionName,
          creative_name: tile.dataset.creativeName,
          creative_slot: tile.dataset.creativeSlot,
        });
      });
    }

    trackAgeVerificationPass(data) {
      if (!data?.verification_method) return;

      Shopify.analytics.publish('on_age_verification_pass', {
        event: 'age_verification_pass',
        verification_method: data.verification_method,
      });
    }

    trackAgeVerification() {
      document.addEventListener('ageGateConfirmed', (e) => {
        const gate = document.querySelector('[data-section-type="age-gate"]');
        this.trackAgeVerificationPass({
          verification_method:
            e.detail?.verification_method || gate?.dataset?.verificationMethod || 'yes_no_button',
        });
      });
    }

    static get PENDING_LOGIN_KEY() {
      return 'pk_pending_login_method';
    }

    markPendingLogin(loginMethod) {
      if (!loginMethod) return;
      try {
        sessionStorage.setItem(AlteregoAnalytics.PENDING_LOGIN_KEY, loginMethod);
      } catch (error) {
        /* ignore */
      }
    }

    getPendingLoginMethod() {
      try {
        return sessionStorage.getItem(AlteregoAnalytics.PENDING_LOGIN_KEY);
      } catch (error) {
        return null;
      }
    }

    clearPendingLogin() {
      try {
        sessionStorage.removeItem(AlteregoAnalytics.PENDING_LOGIN_KEY);
      } catch (error) {
        /* ignore */
      }
    }

    trackLogin(data) {
      if (!data || data.user_id == null || data.user_id === '') return;
      console.log('trackLogin', data);
      Shopify.analytics.publish('on_login', {
        event: 'login',
        user_id: String(data.user_id),
        account_type: data.account_type || 'B2C',
        login_method: data.login_method || '',
      });
    }

    trackPostLogin() {
      const loginMethod = this.getPendingLoginMethod();
      if (!loginMethod) return;

      if (!window.pkCustomer?.id) {
        this.clearPendingLogin();
        return;
      }

      this.trackLogin({
        user_id: window.pkCustomer.id,
        account_type: window.pkCustomer.account_type,
        login_method: loginMethod,
      });
      this.clearPendingLogin();
    }

    trackLoginInitiation() {
      document.addEventListener('submit', (e) => {
        const form = e.target?.closest?.('form[data-analytics-login-form]');
        if (!form || window.pkCustomer?.id) return;
        this.markPendingLogin(form.dataset.analyticsLoginMethod || 'email');
      });

      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-analytics-login-method]');
        if (!trigger || window.pkCustomer?.id) return;
        this.markPendingLogin(trigger.dataset.analyticsLoginMethod);
      });
    }

    trackPlpSelectItem() {
      document.addEventListener('click', (e) => {
        const card = e.target.closest('[data-analytics-select-item]');
        if (!card) return;

        if (e.target.closest('button, product-form, .quick-add, .quick-add__submit, quantity-popover')) return;

        const link = e.target.closest('a[href*="/products/"]');
        if (!link || !card.contains(link)) return;

        const index = parseInt(card.dataset.index, 10);
        this.trackSelectItem({
          item_id: card.dataset.itemId,
          item_name: card.dataset.itemName,
          item_list_name: card.dataset.itemListName,
          item_list_id: card.dataset.itemListId,
          index: Number.isFinite(index) ? index : 0,
        });
      });
    }

    trackQuantityChange(data) {
      if (!data || data.item_id == null || data.item_id === '') return;
      if (data.old_quantity === data.new_quantity) return;

      Shopify.analytics.publish('on_quantity_change', {
        event: 'quantity_change',
        item_id: data.item_id,
        item_name: data.item_name || '',
        old_quantity: data.old_quantity,
        new_quantity: data.new_quantity,
        price: data.price,
      });
    }

    trackCartQuantityChange() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

      let pending = null;

      document.addEventListener('change', (e) => {
        const input = e.target.closest('cart-items input.quantity__input[data-index]');
        if (!input) return;

        const oldQty = parseInt(input.getAttribute('value'), 10);
        const newQty = parseInt(input.value, 10);
        if (!Number.isFinite(oldQty) || !Number.isFinite(newQty) || oldQty === newQty) return;

        pending = {
          item_id: input.dataset.itemId,
          item_name: input.dataset.itemName || '',
          old_quantity: oldQty,
          new_quantity: newQty,
          price: (parseInt(input.dataset.itemPrice, 10) || 0) / 100,
          variantId: input.dataset.quantityVariantId,
        };
      });

      subscribe(PUB_SUB_EVENTS.cartError, () => {
        pending = null;
      });

      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (!pending || event.source !== 'cart-items') return;
        if (event.cartData?.errors) {
          pending = null;
          return;
        }

        let newQty = pending.new_quantity;
        const variantId = String(pending.variantId || '');
        const items = event.cartData?.items;
        if (variantId && Array.isArray(items)) {
          const line = items.find((item) => String(item.variant_id) === variantId);
          if (line && line.quantity != null) newQty = line.quantity;
        }

        this.trackQuantityChange({
          item_id: pending.item_id,
          item_name: pending.item_name,
          old_quantity: pending.old_quantity,
          new_quantity: newQty,
          price: pending.price,
        });

        pending = null;
      });
    }
}

function bootAlteregoAnalytics() {
  window.alteregoAnalytics = new AlteregoAnalytics();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootAlteregoAnalytics, { once: true });
} else {
  bootAlteregoAnalytics();
}